import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import ContinentFilterOptionInformationFactory from '../filter/location/continent/ContinentFilterOptionInformationFactory';

class ContinentFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.CONTINENT,
			ContinentFilterOptionInformationFactory.getContinentFilterInformation(),
			ContinentFilterOptionInformationFactory.getContinentFilterOptionValues(),
		);
	}
}

export default new ContinentFilterDefinition();
